import styled from 'styled-components';

export const ImportProgressCard = styled.div`
  border: 1px solid var(--bs-border-color);
  border-radius: 0.5rem;
  padding: 1rem;
  margin-bottom: 0.75rem;
  background: var(--bs-body-bg);
`;

export const ImportProgressHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.5rem;
`;

export const ImportProgressTitle = styled.span`
  font-weight: 500;
  font-size: 0.875rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const ImportProgressBar = styled.div`
  height: 4px;
  background: var(--bs-secondary-bg);
  border-radius: 2px;
  overflow: hidden;
  margin-top: 0.5rem;
`;

export const ImportProgressBarFill = styled.div<{ $percent: number; $variant: 'primary' | 'success' | 'danger' | 'warning' }>`
  height: 100%;
  width: ${(p) => p.$percent}%;
  background: var(--bs-${(p) => p.$variant});
  transition: width 0.3s ease;
`;
